"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueMany = queueMany;
exports.dequeue = dequeue;
exports.dequeueMany = dequeueMany;
function queueMany(queueMutationDescriptions) {
    return {
        type: "QueueMany",
        queueMutationDescriptions
    };
}
function dequeue(mutation) {
    return {
        type: "Dequeue",
        mutation
    };
}
function dequeueMany(mutations) {
    return {
        type: "DequeueMany",
        mutations
    };
}
//# sourceMappingURL=mutations-queue-actions.js.map